package com.milta.core.localization.translations.pl

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Zdjęcie",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "wysłano przed chwilą",
    fileWaitingConnectionLabel = "czeka na połączenie",
    analysingTitle = "Odczytywanie dokumentu…",
    analysingSubtitle = "Wyodrębnianie dostaw może potrwać kilka sekund.",
    analysingSubtitlePdf = "Claude Haiku wyodrębnia dostawy — może to potrwać kilka sekund w przypadku zeskanowanego PDF-a.",
    stepFileSent = "Plik wysłany",
    stepExtracting = "Wyodrębnianie pól",
    stepReview = "Sprawdzenie przed dodaniem",
    successTitle = "Wykryto dostawę",
    successSubtitle = "Sprawdź informacje przed dodaniem ich do trasy.",
    addToRouteButton = "Dodaj do trasy",
    scanAnotherButton = "Zeskanuj inny dokument",
    partialTitle = "Prawie kompletne",
    partialSubtitle = "Jednego pola nie udało się odczytać z dokumentu.",
    missingFieldPlaceholder = "Do uzupełnienia…",
    partialBannerText = "Niektórych informacji nie udało się odczytać. Możesz zatwierdzić dane w takiej formie i uzupełnić je później, albo wysłać czytelniejszy dokument.",
    retryFileButton = "Wyślij inny plik",
    validateAndContinueButton = "Zatwierdź i kontynuuj",
    errorTitleUnreadable = "Nieczytelny dokument",
    errorTitleMissingFields = "Nie znaleziono informacji",
    errorTitleNetworkError = "Problem podczas analizy",
    errorTitleGeneric = "Analiza nie powiodła się",
    errorSubtitle = "Nie udało się wykryć dostawy w tym pliku.",
    errorBannerSuffixUnreadable = "obraz jest zbyt ciemny lub tekst jest przycięty. Zrób dobrze wykadrowane, dobrze oświetlone zdjęcie lub wyślij czytelniejszy plik.",
    errorBannerSuffixMissingFields = "nie znaleziono żadnych przydatnych informacji. Sprawdź zawartość pliku lub wyślij inny.",
    errorBannerSuffixNetworkError = "usługa analizy napotkała problem z siecią. Spróbuj ponownie za chwilę.",
    errorBannerSuffixGeneric = "podczas analizy wystąpił nieoczekiwany błąd. Spróbuj ponownie lub wyślij inny plik.",
    retryWithNewFileButton = "Spróbuj ponownie z innym plikiem",
    manualEntryButton = "Wprowadź ręcznie",
    newDocumentButton = "Zaimportuj nowy dokument",
    serviceUnavailableTitle = "Usługa tymczasowo niedostępna",
    serviceUnavailableSubtitle = "Automatyczna analiza nie odpowiada w tej chwili.",
    serviceUnavailableBanner = "Spróbuj ponownie za chwilę lub w tym czasie uzupełnij dostawę ręcznie.",
    offlineTitle = "Jesteś offline",
    offlineSubtitle = "Twój plik jest gotowy, ale nie został jeszcze wysłany.",
    offlineBanner = "Połącz się ponownie z internetem, a następnie uruchom analizę ponownie. Nic nie zostało wysłane do serwera — nic nie zostało odliczone od Twojego kredytu AI.",
    retryOfflineButton = "Spróbuj ponownie — brak połączenia",
    unsupportedFormatBanner = "Nieobsługiwany format pliku. Wybierz zdjęcie, plik PDF lub Excel/CSV.",
    validationTitle = "Sprawdź dostawy",
    fileRejectedTitle = "Plik nie został wysłany",
    fileRejectedSubtitle = "Wybierz inny plik, aby kontynuować.",
    bannerFileRequired = "nie wybrano żadnego pliku. Wybierz plik PDF, aby kontynuować.",
    bannerInvalidPdfFormat = "nieobsługiwany format. Tutaj akceptowane są tylko pliki PDF.",
    bannerFileTooLarge = "plik jest zbyt duży. Wybierz lżejszy plik PDF.",
    chooseAnotherFileButton = "Wybierz inny plik",
    processingCanLeaveNote = "Twój plik został wysłany. Możesz opuścić ten ekran, analiza trwa dalej. Swój import znajdziesz w „Importuj dostawy”.",
    uploadingPhotoStep = "Wysyłanie zdjęcia",
    uploadingFileStep = "Wysyłanie pliku",
    photoSentStep = "Zdjęcie wysłane",
    uploadProgress = "%1 z %2",
    uploadingPhotoBanner = "Trwa wysyłanie. Nie zamykaj tego ekranu do końca wysyłania: analiza rozpocznie się, gdy tylko zdjęcie zostanie odebrane.",
    uploadingFileBanner = "Trwa wysyłanie. Nie zamykaj tego ekranu do końca wysyłania: analiza rozpocznie się, gdy tylko plik zostanie odebrany.",
    cancelUploadButton = "Anuluj wysyłanie",
    cancelImportButton = "Anuluj import",
    cancelImportDialogTitle = "Anulować ten import?",
    cancelImportAnalysingScanMessage = "Analiza zostanie natychmiast zatrzymana i do Twojej trasy nie zostanie dodana żadna dostawa. Już rozpoczęta analiza nadal zostaje odliczona od Twojego kredytu AI.",
    cancelImportAnalysingFileMessage = "Analiza zostanie natychmiast zatrzymana i do Twojej trasy nie zostanie dodana żadna dostawa. Już rozpoczęta analiza nadal zostaje odliczona od Twojego kredytu AI.",
    cancelImportConfirmButton = "Tak, anuluj import",
    continueAnalysisButton = "Kontynuuj analizę",
    cancelImportReviewMessage = "Wykryte dostawy (%s) zostaną usunięte i żadna nie zostanie dodana do Twojej trasy. Wrócisz do wyboru źródła.",
    cancelImportReviewMessageSingle = "Wykryta dostawa zostanie usunięta i nie zostanie dodana do Twojej trasy. Wrócisz do wyboru źródła.",
    continueReviewButton = "Kontynuuj sprawdzanie",
    importCancelledNotice = "Import anulowany. Nie dodano żadnej dostawy.",
    serviceUnavailableRetryBanner = "Twój plik jest zachowany. Uruchom analizę ponownie bez ponownego wysyłania pliku lub w międzyczasie uzupełnij dostawę ręcznie.",
    serviceUnavailableExhaustedBanner = "Nie udało się przeanalizować tego dokumentu. Dodaj dostawy ręcznie lub zacznij od nowa z nowym dokumentem.",
    errorTitleTooLong = "Dokument jest za długi",
    errorSubtitleTooLong = "Ten dokument zawiera zbyt wiele dostaw, aby przeanalizować go za jednym razem.",
    errorBannerSuffixTooLong = "podziel go na kilka krótszych plików lub wprowadź dostawy ręcznie.",
    errorTitleTooLarge = "Dokument jest za duży",
    errorSubtitleTooLarge = "Ten dokument przekracza rozmiar, który analiza może przetworzyć.",
    errorBannerSuffixTooLarge = "zmniejsz jego rozmiar lub podziel go na kilka plików albo wprowadź dostawy ręcznie.",
    errorTitleNoDeliveries = "Nie znaleziono dostaw",
    errorSubtitleNoDeliveries = "Dokument został odczytany, ale nie znaleziono w nim żadnych dostaw.",
    errorBannerSuffixNoDeliveries = "sprawdź, czy zawiera listę dostaw, lub wprowadź je ręcznie.",
    errorTitleSourceExpired = "Plik wygasł",
    errorSubtitleSourceExpired = "Ten plik nie jest już dostępny do ponownej analizy.",
    errorBannerSuffixSourceExpired = "wybierz go ponownie, aby uruchomić analizę.",
    errorTitleOriginRouteDeleted = "Import anulowany",
    errorSubtitleOriginRouteDeleted = "Trasa źródłowa została usunięta: ten import jest anulowany.",
    errorBannerSuffixOriginRouteDeleted = "import anulowany, nie dodano żadnej dostawy.",
    activeImportHeader = "Import w toku",
    activeImportAnalysingPill = "Analiza w toku",
    activeImportFailedPill = "Analiza nie powiodła się",
    activeImportReadyPill = "Gotowe do zatwierdzenia",
    activeImportRunningNote = "Jeden import naraz. Poczekaj na zakończenie analizy lub ją anuluj, aby zaimportować inny dokument.",
    activeImportFailedNote = "Jeden import naraz. Uruchom ponownie lub anuluj ten import, aby zaimportować inny dokument.",
    activeImportReadyNote = "Zaimportowane dostawy są gotowe. Dotknij, aby je zatwierdzić.",
    activeImportRunningOtherRouteNote = "Trwa analiza importu dla trasy z dnia %s. Dotknij, aby otworzyć tę trasę. Poczekaj na zakończenie analizy lub ją anuluj, aby zaimportować inny dokument.",
    activeImportReadyOtherRouteNote = "Dostawy dla trasy z dnia %s są gotowe. Dotknij, aby otworzyć tę trasę i je zatwierdzić.",
    activeImportFailedOtherRouteNote = "Import dla trasy z dnia %s nie powiódł się. Uruchom ponownie lub anuluj ten import, aby zaimportować inny dokument.",
    activeImportRunningNewRouteNote = "Trwa analiza importu dla nowej trasy. Dotknij, aby wznowić jej tworzenie. Poczekaj na zakończenie analizy lub ją anuluj, aby zaimportować inny dokument.",
    activeImportReadyNewRouteNote = "Dostawy dla nowej trasy są gotowe. Dotknij, aby wznowić jej tworzenie i je zatwierdzić.",
    activeImportFailedNewRouteNote = "Import dla nowej trasy nie powiódł się. Uruchom ponownie lub anuluj ten import, aby zaimportować inny dokument.",
    activeImportRouteLink = "Trasa z dnia %s",
    activeImportNewRouteLink = "Nowa trasa (w trakcie tworzenia)",
    weekdayNamesInText = listOf("poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota", "niedziela"),
)
